import {
    type MaybeRefOrGetter,
    toValue,
    type ComputedRef,
    computed,
    inject,
} from 'vue';
import { preconColorsOptionsInjectionKey } from '../symbols';
import {
    type NormalizedPreconColorsGlobalOptions,
    normalizePreconColorsOptions,
} from '../options';

/**
 * Composable that injects the library options into a component.
 *
 * @param override Override the global option values.
 */
export function usePreconColorsOptions(
    override?: MaybeRefOrGetter<
        Partial<NormalizedPreconColorsGlobalOptions> | null | undefined
    >
): ComputedRef<NormalizedPreconColorsGlobalOptions> {
    // This injects global options from the application into the component that uses this composable.
    const options =
        inject(preconColorsOptionsInjectionKey) ??
        normalizePreconColorsOptions();

    // This merges the options with the override values.
    return computed(() => ({
        ...options,
        ...(toValue(override) ?? {}),
    }));
}
